import { ApiService } from "../model/Api.model";
import { AxiosInstance } from "axios";
import { IOfficer } from "../interface/user/officer/IOfficer";
import { IEfficinecyReport } from "../interface/dashboard/IEfficinecyReport";

enum OfficerServiceEnum {
  getAll = "/all",
  save = "",
  getById = "/",
  getDiligenceEfficiencyReport = "/get-diligence-efficiency-report",
  getPostPurchaseEfficiencyReport = "/get-post-purchase-efficiency-report"
}

export default class OfficerService extends ApiService {
  constructor(restClient: AxiosInstance) {
    super(restClient, "/officer");
  }

  public getAll = async (): Promise<IOfficer[]> => await this.GET(OfficerServiceEnum.getAll);
  public getById = async (id): Promise<IOfficer> => await this.GET(OfficerServiceEnum.getById + id);
  public save = async (data): Promise<IOfficer> => await this.POST(OfficerServiceEnum.save, data);
  public getDiligenceEfficiencyReport = async (): Promise<IEfficinecyReport[]> => await this.GET(OfficerServiceEnum.getDiligenceEfficiencyReport);
  public getPostPurchaseEfficiencyReport = async (): Promise<IEfficinecyReport[]> => await this.GET(OfficerServiceEnum.getPostPurchaseEfficiencyReport);
}
